import { render, staticRenderFns } from "./mianxiang.vue?vue&type=template&id=66a67101&"
import script from "./mianxiang.vue?vue&type=script&lang=ts&"
export * from "./mianxiang.vue?vue&type=script&lang=ts&"
import style0 from "./mianxiang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports